import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { ContainerService } from '../_services';
import * as ContainerActions from '../_actions/container';
import * as WarehouseActions from '../_actions/warehouse';

@Injectable({
  providedIn: 'root',
})
export class ContainerEffects {
  loadContainers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ContainerActions.loadContainers),
      mergeMap(() =>
        this.containerService.getContainers().pipe(
          map((containers) => ContainerActions.loadContainersSuccess({ containers })),
          catchError((error) => of(ContainerActions.loadContainersFailure({ error })))
        )
      )
    )
  );

  addContainer$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ContainerActions.addContainer),
      mergeMap(({ container }) =>
        this.containerService.saveContainer(container).pipe(
          map((savedContainer) =>
            ContainerActions.addContainerSuccess({ container: savedContainer })
          ),
          catchError((error) => of(ContainerActions.addContainerFailure({ error })))
        )
      )
    )
  );

  updateContainer$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ContainerActions.updateContainer),
      mergeMap(({ container }) =>
        this.containerService.saveContainer(container).pipe(
          map((updatedContainer) =>
            ContainerActions.updateContainerSuccess({ container: updatedContainer })
          ),
          catchError((error) => of(ContainerActions.updateContainerFailure({ error })))
        )
      )
    )
  );

  deleteContainer$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ContainerActions.deleteContainer),
      mergeMap(({ id }) =>
        this.containerService.deleteContainer(id).pipe(
          map(() => ContainerActions.deleteContainerSuccess({ id })),
          catchError((error) => of(ContainerActions.deleteContainerFailure({ error })))
        )
      )
    )
  );

  reloadWarehousesAfterContainer$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ContainerActions.addContainerSuccess, ContainerActions.updateContainerSuccess),
      map(() => WarehouseActions.loadWarehouses())
    )
  );

  constructor(
    private actions$: Actions,
    private containerService: ContainerService
  ) {}
}
